// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useEffect, useMemo, useRef, useState} from 'react';
import cn from 'classnames';
import etask from 'zetask';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {App_context} from 'hola_app_context';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {Input} from '../../../../hola/pub/lib/input';
import {i_select_item, Select} from '../../../../hola/pub/lib/select';
import {Textarea} from '../../../../hola/pub/lib/textarea';
import {Button} from '../../../../shared/ui/button/button';
import {Btn_loader} from './btn_loader';
import {t_orders} from '../../../../hola/pub/ui/pro/cp/orders';
import Icon_arrow_right from '../../img/icons/arrow_right.svg';
import Icon_upload from '../../img/icons/24/upload.svg';
import Icon_attached_file from '../../img/icons/24/attached_file.svg';
import Icon_check from '../../img/icons/16/check.svg';
import Icon_trash from '../../img/icons/trash.svg';
import Icon_check_thin from '../../img/icons/check_thin.svg';
import Icon_x from '../../img/icons/x.svg';
import Icon_damaged_file from '../../img/icons/24/damaged_file.svg';
import Icon_warning from '../../../../oculus/pub/img/icons/24/warning-line.svg';

import styles from './support_form.module.less';

const MAX_FILE_SIZE = 50 * 1024 * 1024;

interface i_file_upload {
    files: {
      status: string,
      progress: number,
      file: File,
    }[];
    set_files: React.Dispatch<React.SetStateAction<i_file_upload['files']>>;
}

const File_upload = ({files, set_files}: i_file_upload)=>{
    const {theme} = useContext(Settings_context);
    const [err, set_err] = useState('');
    const {width} = use_screen();
    const file_input_ref = useRef(null);
    const handle_file_change = e=>{
        const selected_files = Array.from(e.target.files);
        process_files(selected_files);
        if (file_input_ref.current)
            file_input_ref.current.value = '';
    };
    const handle_drag_over = e=>e.preventDefault();
    const handle_drop = e=>{
        e.preventDefault();
        set_err('');
        const dropped_files = Array.from(e.dataTransfer.files);
        process_files(dropped_files);
    };
    const remove_file = index=>{
        set_files(prev=>{
            const new_files = prev.filter((_, i)=>i != index);
            if (file_input_ref.current && new_files.length < prev.length)
                file_input_ref.current.value = '';
            return new_files;
        });
    };
    const process_files = new_files=>{
        const valid_files = [];
        const existing_files = new Set(files.map(f=>f.file.name));
        let total_size = files.reduce((sum, f)=>sum + f.file.size, 0);
        for (const file of new_files)
        {
            if (file.size > MAX_FILE_SIZE)
            {
                set_err('size_exceeded');
                return;
            }
            const potential_total_size = total_size + file.size;
            if (potential_total_size > MAX_FILE_SIZE)
            {
                set_err('size_exceeded');
                return;
            }
            else if (!existing_files.has(file.name))
            {
                valid_files.push({
                    file,
                    progress: 0,
                    status: 'processing',
                });
                existing_files.add(file.name);
                total_size += file.size;
            }
        }
        if (valid_files.length > 0)
        {
            set_files(prev=>[...prev, ...valid_files]);
            valid_files.forEach((file_obj, i)=>{
                read_file(i+files.length, file_obj.file);
            });
        }
    };
    const read_file = (file_index, file)=>{
        const reader = new FileReader();
        reader.onerror = e=>{
            remove_file(file_index);
            console.error('Processing error:', e);
            set_err('processing_err');
        };
        reader.onloadend = ()=>{
            set_files(prev=>{
                const updated_files = [...prev];
                if (updated_files[file_index] &&
                    updated_files[file_index].status != 'error')
                {
                    updated_files[file_index].status = 'ready';
                }
                return updated_files;
            });
        };
        reader.readAsArrayBuffer(file);
    };
    const add_files_text = !err ?
        <p className={cn(theme.p14, theme.color_n500)}>
          <span className={cn(theme.color_n700, styles.underline_med)}>
            Add files
          </span>
          {width >= 768 ? ' or drop files here ' : ' '}
          <span className={cn(theme.P, theme.p12, theme.color_n500)}>
            (50 MB max total)</span>
        </p> : err == 'size_exceeded' ?
        <p className={cn(theme.p14, theme.color_err_bold)}>
          Upload failed&nbsp;
          <span className={cn(theme.P, theme.p14, theme.color_err_bold)}>
            (50 MB max total size) </span>
          <span className={styles.underline_med}>try again</span>
        </p> :
        <p className={cn(theme.p14, theme.color_err_bold)}>
          Upload failed, please&nbsp;
          <span className={styles.underline_med}>try again</span>
        </p>;
    const add_files_icon = !err ? <Icon_upload /> : err == 'size_exceeded' ?
        <Icon_warning /> : <Icon_damaged_file />;
    return <div>
      <div className={cn(styles.add_files, err && styles.add_files_error)}
        onDragOver={handle_drag_over}
        onDrop={handle_drop}
        onClick={()=>{
          set_err('');
          const file_input = document.querySelector('[class^="file_input"]');
          if (file_input)
            (file_input as HTMLElement).click();
        }}>
        <div className={styles.add_files_text}>
          <div className={styles.upload_icon}>{add_files_icon}</div>
          {add_files_text}
        </div>
        <input type='file' className={styles.file_input} multiple
          onChange={handle_file_change} />
      </div>
      {files.length > 0 && <div>
        <ul className={styles.files}>
          {files.map((file_obj, index)=>{
            return <li key={index} className={cn(styles.file,
              file_obj.status == 'processing' && styles.file_processing)}>
              <div className={styles.file_data}>
                <Icon_attached_file />
                <div className={styles.file_name_and_size}>
                  <p className={cn(theme.p14, theme.med)}>
                    {file_obj.file.name}
                  </p>
                  <p className={cn(theme.p12, theme.color_n400)}>
                    {(file_obj.file.size / (1024 * 1024)).toFixed(1)} MB
                    {file_obj.status == 'ready' && ' - Uploaded'}
                  </p>
                </div>
              </div>
              {file_obj.status == 'ready' &&
                <Icon_check className={styles.uploaded_icon} />}
              <Button caption={<Icon_trash />} size='xxs'
                cls={styles.remove_file} color='transparent'
                on_click={()=>remove_file(index)} />
            </li>;
          })}
        </ul>
      </div>}
    </div>;
};

export const Support_req_status = ({err}: {err: boolean;})=>{
  const {theme} = useContext(Settings_context);
  return <div className={cn(styles.support_req_status)}>
    <div className={cn(styles.icon_check_wrapper,
      err && styles.submit_fail)}>
      {!err ? <Icon_check_thin /> : <Icon_x />}
    </div>
    <div className={styles.status_text_container}>
      <p className={cn(theme.p14, theme.color_n700, theme.bold)}>
        {!err ? 'Support request submited' : 'Support Request Unsuccessful'}
      </p>
      <p className={cn(theme.p12, theme.color_n500)}>
        {!err ? 'Your request was successfully sent.' :
          <span>
            We apologize for the inconvenience. Please reach out to our
            support team via email at&nbsp;
            <a href='mailto:support@toolip.io'
              className={cn(styles.underline, theme.color_n500)}>
              support@toolip.io
            </a>.
          </span>}
      </p>
    </div>
  </div>;
};

const support_req_items: i_select_item[] = [
    {
        value: 'shared_dc',
        title: 'Shared Datacenter Proxies',
    }, {
        value: 'dedicated_dc',
        title: 'Dedicated Datacenter Proxies',
    }, {
        value: 'isp',
        title: 'Global ISP Proxies',
    }, {
        value: 'isp_plus',
        title: 'Search Engine ISP Proxies',
    }, {
        value: 'smart_resi',
        title: 'Rotating Residential Proxies',
    }, {
        value: 'general',
        title: 'General',
    }
];

interface i_support_form {
  on_close: ()=>void;
  support_form_data?: {token: string; product: string};
  orders?: t_orders;
}

export const Support_form = ({on_close, support_form_data, orders}:
i_support_form)=>{
    const {theme, show_popup, close_popup} = useContext(Settings_context);
    const {user} = useContext(App_context);
    const [is_disabled, set_is_disabled] = useState(true);
    const [files, set_files] = useState([]);
    const [is_submitting, set_is_submitting] = useState(false);
    const [err, set_err] = useState(false);
    const [msg, set_msg] = useState('');
    const [product, set_product] = useState('');
    const [token_number, set_token_number] = useState('');
    const [subject, set_subject] = useState('');
    const close_req_status = ()=>{
        const elm = document.querySelectorAll('[class*="support_req_status"]');
        elm.forEach(el=>{
          Array.from(el.classList)
              .filter(cl=>cl.startsWith('visible'))
              .forEach(cl=>el.classList.remove(cl));
        });
        setTimeout(()=>close_popup('support_req_status'), 500);
    };
    const show_status_popup = ()=>{
        show_popup('support_req_status',
            ()=><Support_req_status err={err}/>,
            {
                anchor_element: document.body,
                parent: document.body,
                strategy: 'bind auto auto center',
                cls: styles.support_req_status_popup,
            }
        );
        const elm = document.querySelectorAll('[class*="support_req_status"]');
        elm.forEach(el=>el.classList.add(styles.visible));
    };
    useEffect(()=>{
        if (product && msg && subject)
            set_is_disabled(false);
        else if (!is_disabled && (!product || !msg || !subject))
            set_is_disabled(true);
    }, [product, msg, subject]);
    const filtered_orders = useMemo(()=>{
        if (!orders)
            return;
        return Object.entries(orders).map(([product_name, p_orders])=>[
            product_name,
            p_orders.filter(order=>!order.disabled)
        ]).filter(([, p_orders])=>p_orders.length > 0)
        .reduce((acc, [product_name, p_orders])=>{
            acc[product_name as string] = p_orders;
            return acc;
        }, {});
    }, [orders]);
    useEffect(()=>{
        if (filtered_orders && Object.keys(filtered_orders).length == 1)
        {
            const prod = Object.keys(filtered_orders)[0];
            set_product(prod);
            if (filtered_orders[prod].length == 1)
                set_token_number(filtered_orders[prod][0].client_id);
        }
        if (support_form_data?.product && !product)
            set_product(support_form_data.product);
        if (support_form_data?.token && !token_number)
            set_token_number(support_form_data.token);
    }, [support_form_data, filtered_orders]);
    const upload_files = ()=>etask(function*(){
        const form = new FormData();
        files.forEach(f=>{
            if (f.status == 'ready')
                form.append('file', f.file);
        });
        try {
            const upload_res = yield fetch('/upload_attachments_zendesk', {
                method: 'POST',
                body: form,
                auto_content_type: true,
            });
            if (!upload_res.tokens || upload_res.tokens.length == 0)
            {
                console.error('File upload failed: No tokens returned');
                return [];
            }
            return upload_res.tokens;
        } catch(e){
            console.error('Error uploading files:', e);
            return [];
        }
    });
    const on_submit = ev=>etask(function*(){
        ev.preventDefault();
        set_is_disabled(true);
        set_is_submitting(true);
        const comment = {
            html_body: `<p>${msg.replace(/\r\n|\n/g, '<br>')}</p>
            <br>
            <div>Product: ${product}</div>
            <div>Order/Token number: ${token_number}</div>`,
        };
        let upload_tokens = [];
        if (files.length > 0)
        {
            upload_tokens = yield upload_files();
            comment['uploads'] = upload_tokens;
        }
        const ticket_data = {
            subject: subject,
            requester: {
                name: user.emails[0].value.split('@')[0],
                email: user.emails[0].value,
            },
            comment,
        };
        if (files.length == 0 || files.length > 0 && upload_tokens.length > 0)
        {
            try {
                const res = yield fetch('/create_zendesk_ticket', {
                    method: 'POST',
                    body: ticket_data,
                });
                const ticket_res = yield res;
                if (ticket_res.ticket)
                {
                    set_err(false);
                    show_status_popup();
                    setTimeout(()=>close_req_status(), 5000);
                    set_files([]);
                    set_subject('');
                    set_product('');
                    set_token_number('');
                    set_msg('');
                }
                else
                    set_err(true);
            } catch(e){
                set_err(true);
                show_status_popup();
                setTimeout(()=>close_req_status(), 10000);
                console.error('Error creating ticket:', e);
            } finally {
                set_is_submitting(false);
                on_close();
            }
        }
    });
    const btn_caption = <>
      {is_submitting ?
        <span><Btn_loader/></span> :
        <span>Submit</span>}
    </>;
    return <div className={styles.support_form_modal}>
      <p className={cn(theme.p18, theme.med, theme.color_n700)}>
        Submit support request
      </p>
      <section className={styles.form_section}>
        <div className={styles.inputs_container}>
          <Input label='Subject' title='' value={subject}
            on_change={set_subject} cl={styles.subject} />
          <Select label='Product' title='Select relevant product'
            value={product} class_name={styles.select_prod}
            svg_cls={styles.select_chevron} items={support_req_items}
            border_class_name={styles.dropdown_list}
            on_select={(_, v)=>set_product(v)} />
          <div className={styles.order_number}>
            <Input label='Order/Token number (optional)'
              value={token_number} on_change={set_token_number} />
            <p className={cn(theme.p10, theme.color_n400)}>
              You can find this on your order page
            </p>
          </div>
        </div>
        <p className={cn(theme.p12, theme.color_n400)}>Description</p>
        <Textarea placeholder='Tell us a bit more about it' value={msg}
          on_change={v=>set_msg(v)} cls={styles.description}
          min_height={132} />
      </section>
      <File_upload files={files} set_files={set_files}/>
      <Button caption={btn_caption}
        icon_right={is_submitting ? null : <Icon_arrow_right/>}
        cls={styles.submit_btn} disabled={is_disabled} on_click={on_submit} />
    </div>;
};
